import { NotificationModel } from "@src/core/domain/notification/notification.model";
import { Observable } from "rxjs";

export abstract class PutNotificationRepositories {
    abstract putNotification(param: any): Observable<NotificationModel>; 
}